export class BookingReference {
  constructor(bookingReferenceInfo) {
    if (!bookingReferenceInfo) {
      this.bookingReferenceId = null
      this.clientId = null
      this.title = null
      this.referenceType = null
      this.values = null
      this.isMandatory = false
      this.regex = null
      this.defaultValueType = null
      this.defaultValue = null
      this.userPropertyId = null
      this.status = null
    } else {
      this.bookingReferenceId = bookingReferenceInfo.id
        ? bookingReferenceInfo.id
        : null
      this.clientId = bookingReferenceInfo.clientId
        ? bookingReferenceInfo.clientId
        : null
      this.title = bookingReferenceInfo.title
        ? bookingReferenceInfo.title
        : null
      this.referenceType = bookingReferenceInfo.referenceType
        ? bookingReferenceInfo.referenceType
        : null
      this.values = bookingReferenceInfo.values
        ? bookingReferenceInfo.values
        : null
      this.isMandatory = Boolean(bookingReferenceInfo.isMandatory)
      this.regex = bookingReferenceInfo.regex || null
      this.defaultValueType = bookingReferenceInfo.defaultValueType || null
      this.defaultValue = bookingReferenceInfo.defaultValue || null
      this.userPropertyId =
        typeof bookingReferenceInfo.userPropertyId === 'number'
          ? bookingReferenceInfo.userPropertyId
          : null
      this.status = bookingReferenceInfo.status || null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}
